import { useEffect, useState } from 'react';

export function useViewportVisibility<T extends Element>(
  ref: React.RefObject<T | null>,
  threshold: number | number[] = 0
) {
  const [hasEntered, setHasEntered] = useState(false);
  const [isInView, setIsInView] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) {
      return;
    }

    if (typeof window === 'undefined' || !('IntersectionObserver' in window)) {
      setIsInView(true);
      setHasEntered(true);
      return;
    }

    const observer = new IntersectionObserver(
      ([entry]) => {
        const intersecting = entry.isIntersecting;

        setIsInView(intersecting);

        if (intersecting) {
          setHasEntered(true); // sticky
        }
      },
      { threshold }
    );

    observer.observe(el);

    return () => observer.disconnect();
  }, [ref, threshold]);

  return { hasEntered, isInView } as const;
}
